import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs,
  orderBy,
  limit
} from "firebase/firestore";
import { db } from "../../firebase";
import Cookies from "js-cookie";
import { Randomcode } from "../../components_root/rendom_code";
import { Serial_number } from "../../components_root/serial_number";
import { number } from "framer-motion";

export const Save_ledger_account = async (data) => {
  const { name, accountguid, account_type } = data || {};
 
  if (!accountguid?.trim()) {
    return { success: false, error: "Missing accountguid" };
  }
  if (!account_type?.trim()) {
    return { success: false, error: "Missing account_type" };
  } 
  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");
  const select_company_uid = Cookies.get("select_company_uid");

  if (!sessiontoken) {
    return { success: false, error: "Session expired. Please relogin." };
  }
  if (!guid) {
    return { success: false, error: "Login expired. Please relogin." };
  }
  if (!select_company_uid || select_company_uid === "undefined" || select_company_uid === "null") {
    return { success: false, error: "Contact service provider." };
  }

  const servicetablename = "accountingfinancedb";
  try {
    // SUBCOLLECTION path
    const ledgerCollection = collection(
      db,
      servicetablename,
      select_company_uid,
      "ledger_accounts"
    );

    // Check duplicate accountguid inside company
    const duplicateQuery = query(
      ledgerCollection,
      where("accountguid", "==", accountguid),
    );

    const duplicateSnap = await getDocs(duplicateQuery);

    if (!duplicateSnap.empty) {
      return { success: false, error: "accountguid already listed." };
    } 
 
    // SAVE AREA
    const tablename = "ledger_accounts";
    const voucherprintCollection = collection(
      db,
      "companies",
      select_company_uid,
      "staff_accounts"
    );
    const lastIndexQuery = query(
      voucherprintCollection, 
        where("accountguid", "==", accountguid),
    ); 
    const lastIndexSnap = await getDocs(lastIndexQuery);

    if (!lastIndexSnap.empty) {
      const lastDoc = lastIndexSnap.docs[0].data();
      // Create ledger under company  
      const parentDocRef = doc(
        db,
        servicetablename,
        select_company_uid,
        tablename,
        accountguid
      );
      const savequery = {
        ...lastDoc,
        ...data,
        companyuid: select_company_uid,
        guid,
        sessiontoken,
        date_time: new Date(),
        date_time_update: new Date(),
        status:false
      };
   
      await setDoc(parentDocRef, savequery); 
      return { success: true };
       };
    } catch (err) {
      console.error("Error saving ledger:", err);
      return { success: false, error: err.message || "Unknown error" };
    }
  };
